import { asMultiStyleConfig } from '../../../../../utils/theme';
var baseStyle = {
  list: {
    maxHeight: '43.75rem',
    width: '100%'
  },
  spinner: {
    color: 'green.500',
    marginTop: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%'
  }
};
export var ActivityFeed = asMultiStyleConfig({
  parts: ['container', 'list'],
  baseStyle
});